/**
 * Tenants API
 * Domain API via HTTP transport (apiTransport) to the backend /api RPC.
 */

import { Tenant, TenantNote } from '@repo/shared-types';
import { apiTransport as router } from './transport';
import { getContext } from './core';

export const tenantsApi = {
  list: async (filters?: Record<string, string>) => {
    const context = getContext();
    return router.get<Tenant[] | { data: Tenant[]; total: number }>('/tenants', context, Object.keys(filters ?? {}).length ? filters : undefined);
  },
  create: async (tenant: Omit<Tenant, 'id' | 'balance' | 'avatar'>) => {
    const context = getContext();
    return router.post<Tenant>('/tenants', tenant, context);
  },
  get: async (id: string) => {
    const context = getContext();
    return router.get<Tenant>(`/tenants/${id}`, context);
  },
  update: async (id: string, updates: Partial<Tenant>) => {
    const context = getContext();
    return router.patch<Tenant>(`/tenants/${id}`, updates, context);
  },
  delete: async (id: string) => {
    const context = getContext();
    return router.delete<{ success: boolean }>(`/tenants/${id}`, context);
  },
  stripeVerification: {
    get: async (tenantId: string) => {
      const context = getContext();
      return router.get<{
        tenantId: string;
        linked: boolean;
        identities: Array<{
          stripeConnectAccountIdSuffix: string;
          stripeCustomerIdSuffix: string;
          updatedAt: string;
        }>;
      }>(`/tenants/${tenantId}/stripe-verification`, context);
    },
  },
  notes: {
    list: async (tenantId: string) => {
      return router.get<TenantNote[]>(`/tenants/${tenantId}/notes`);
    },
    create: async (note: { tenantId: string; content: string }) => {
      const context = getContext();
      return router.post<TenantNote>(`/tenants/${note.tenantId}/notes`, note, context);
    },
    update: async (id: string, updates: { content: string }) => {
      return router.patch<TenantNote>(`/tenants/notes/${id}`, updates);
    },
    delete: async (id: string) => {
      return router.delete<{ success: boolean }>(`/tenants/notes/${id}`);
    }
  }
};

